import { css, Theme } from '@emotion/react'

import { pxToRem, selectors, spacing } from '../theme'

export const getLinkStyle = (theme: Theme) => css`
  color: ${theme.colors.link};
  cursor: pointer;
  /* stylelint-disable-next-line @cash-web/no-hardcoded-font-styles */
  font-weight: ${theme.weights.medium};
  text-decoration: none;
  -webkit-tap-highlight-color: transparent;

  @media (hover: hover) {
    :hover {
      color: ${theme.colors.primaryButtonHover};
    }
  }

  :active {
    color: ${theme.colors.primaryButtonActive};
  }
`

export const getWarningLinkStyle = (theme: Theme) => css`
  ${getLinkStyle(theme)};
  color: ${theme.colors.bannerTextWarn};
  text-decoration: underline;

  @media (hover: hover) {
    :hover {
      color: ${theme.colors.bannerTextWarn};
      opacity: 0.9;
      background: transparent;
    }
  }

  :active {
    color: ${theme.colors.bannerTextWarn};
    opacity: 0.7;
    background: transparent;
  }
`

export const getErrorLinkStyle = (theme: Theme, isBanner = true) => css`
  ${getLinkStyle(theme)};
  color: ${isBanner ? theme.colors.bannerTextError : theme.colors.error};
  text-decoration: underline;

  @media (hover: hover) {
    :hover {
      color: ${theme.colors.errorHover};
    }
  }

  :active,
  :visited {
    color: ${theme.colors.errorPressed};
  }
`

// TODO: should be deprecated after Arcade migration
export const getMarkdownLinkStyle = (theme: Theme) => css`
  a {
    color: ${theme.colors.label};
    word-break: break-word;

    @media (hover: hover) {
      &:hover {
        color: ${theme.colors.secondaryLabel};
      }
    }
  }
`

export const getArcadeLinkStyles = (theme: Theme) => css`
  cursor: pointer;
  color: ${theme.arcadeColors.semantic.textLink};
  text-decoration: underline;
  outline: none;
  position: relative;

  &:hover {
    color: ${theme.arcadeColors.semantic.textSubtle};
  }

  &:visited {
    color: ${theme.arcadeColors.semantic.textLinkVisited};
  }

  ${selectors.keyboard} &:focus::before {
    content: '';
    position: absolute;
    inset: -${spacing.xxs} -${spacing.xxs} -${spacing.xxs} -${spacing.xxs};
    border: 0.125rem solid ${theme.arcadeColors.semantic.borderProminent};
    border-radius: ${pxToRem(4)};
  }
`
